export type Environment = 'dev' | 'staging' | 'prod';

export const ALL_ENVIRONMENTS: Environment[] = ['dev', 'staging', 'prod'];

const isEnvironmentName = (value: string): value is Environment =>
  (ALL_ENVIRONMENTS as string[]).includes(value);

/** Environments this build may show, from REACT_APP_NEXUS_ENVIRONMENTS. The dev console gets dev only. */
export const getEnvironments = (): Environment[] => {
  const configured = (process.env.REACT_APP_NEXUS_ENVIRONMENTS ?? 'dev')
    .split(',')
    .map((value) => value.trim())
    .filter(isEnvironmentName);
  return configured.length > 0 ? configured : ['dev'];
};

export const ENVIRONMENT_LABELS: Record<Environment, string> = {
  dev: 'Dev',
  staging: 'Staging',
  prod: 'Prod',
};

export const NEXUS_API_URLS: Record<Environment, string> = {
  dev: process.env.REACT_APP_NEXUS_API_DEV ?? '',
  staging: process.env.REACT_APP_NEXUS_API_STAGING ?? '',
  prod: process.env.REACT_APP_NEXUS_API_PROD ?? '',
};

export const ENVIRONMENT_STORAGE_KEY = 'nexus-ui.environment';

export const NexusPermissions = {
  READ: 'nexus:read',
  WRITE: 'nexus:write',
  BILLING: 'nexus:billing',
  PROVISION: 'nexus:provision',
} as const;

export const routerFutureFlags = { v7_startTransition: true, v7_relativeSplatPath: true };

export const isMockMode = (): boolean => process.env.REACT_APP_USE_MOCKS === 'true';

/** WorkOS organisation the hosted login is pinned to, so Nexus only ever signs in the openr staff organisation. */
export const STAFF_ORGANISATION_ID = process.env.REACT_APP_WORKOS_ORGANIZATION_ID || undefined;
